<div class="pr-large-y">
  <h1 class="font-heading-3 ms-clear bold-type {{ headingClass }}">{{ title }}</h1>
  <p class="font-body-1 nordic-blue-900-text" *ngIf="subtitle">{{ subtitle }}</p>
</div>
